import React, { useContext } from "react";
import { Button, Icon, message } from "antd";
import { useHistory } from "react-router-dom";
import { CourseContext } from "../../../../Store";
import style from "./index.module.scss";
import CountDown from "components/CourseComponents/CountDown";
import moment from "moment";
import CourseHeader from "../../../../components/CourseHeader";
import { endQuestionnaire, QuestionnaireInfo } from "service/question";
import { errorMessage } from "service/service";
import useRequestFn from "../../../../../../utils/useRequestFn";
import BriefInfo from "../../../Components/BriefInfo";

export default function ExerciseDetailHeader({
    exerciseInfo
}: {
    exerciseInfo: QuestionnaireInfo;
}) {
    const history = useHistory();
    const { course, basename } = useContext(CourseContext);
    const [callEndExercise, endExerciseStatus] = useRequestFn(endQuestionnaire);

    async function onEnd() {
        try {
            await callEndExercise(
                course.weekTimeId,
                exerciseInfo.questionnaireId
            );
            history.replace(
                `${basename}/question/static/${exerciseInfo.questionnaireId}`
            );
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    return (
        <CourseHeader
            title={exerciseInfo.questionnaireName}
            info={<BriefInfo {...exerciseInfo} />}
            extra={
                <div className={style.right}>
                    <CountDown
                        key={exerciseInfo?.validityTime}
                        startTime={moment(exerciseInfo.startTime).format(
                            "YYYY-MM-DD HH:mm:ss"
                        )}
                        validityTime={
                            exerciseInfo?.validityTime === "不限"
                                ? 0
                                : parseInt(exerciseInfo.validityTime)
                        }
                        onEnd={onEnd}
                    />
                    <Button
                        type="primary"
                        ghost
                        className={style.button}
                        onClick={onEnd}
                        loading={endExerciseStatus.loading}>
                        {!endExerciseStatus.loading && <Icon type="poweroff" />}
                        结束问卷
                    </Button>
                </div>
            }
        />
    );
}
